import _get from 'lodash/get';
import { a as _objectSpread } from '../chunk-ad6ad343.js';

var global = function global(overrides) {
  return _objectSpread({
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    fontSize: 16
  }, _get(overrides, 'global', {}));
};

export default global;